function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function Home({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16.308 20.868h4.35a.372.372 0 00.379-.363v-7.848c0-1.24-.53-2.435-1.45-3.279l-6.495-5.955a1.646 1.646 0 00-2.22.005l-6.436 5.95A4.466 4.466 0 003 12.643v7.861c0 .2.17.363.379.363h4.344l.03-3.7a1.44 1.44 0 011.439-1.423h5.662c.79 0 1.435.641 1.439 1.428l.015 3.695zm4.35 2h-4.853a1.495 1.495 0 01-1.495-1.484l-.015-3.639H9.748l-.03 3.645a1.498 1.498 0 01-1.495 1.478H3.379a2.375 2.375 0 01-2.38-2.363v-7.86a6.47 6.47 0 012.08-4.737L9.516 1.96a3.659 3.659 0 014.927-.01l6.496 5.954a6.47 6.47 0 012.098 4.754v7.848a2.375 2.375 0 01-2.38 2.363z",
    fill: props.color || "#222",
    fillRule: "evenodd"
  }));
}

const MemoHome = React.memo(Home);
export default MemoHome;